import axios from "axios";
import {
  uploadEventtypeImagesApiRequest,
  uploadImagesCloudinaryApiRequest,
} from "./utils/utils";
import { useSelector } from "react-redux";
import { newEventtype,deleteEventtype, saveAttributeToCatDoc } from "../../redux/actions/eventtypeActions";
import { useDispatch } from "react-redux";

import CreateEventtypePageComponent from "./components/CreateEventtypePageComponent";

const createEventtypeApiRequest = async (formInputs) => {
  const { data } = await axios.post(`/api/eventtypes`, { ...formInputs });
  return data;
};

const AdminCreateEventtypePage = () => {
  const { eventtypes } = useSelector((state) => state.getEventtypes);
  const dispatch = useDispatch();

  return (
    <CreateEventtypePageComponent
      createEventtypeApiRequest={createEventtypeApiRequest}
      uploadEventtypeImagesApiRequest={uploadEventtypeImagesApiRequest}
      uploadImagesCloudinaryApiRequest={uploadImagesCloudinaryApiRequest}
      eventtypes={eventtypes}
      reduxDispatch={dispatch}
      newEventtype={newEventtype}
      deleteEventtype={deleteEventtype}
      saveAttributeToCatDoc={saveAttributeToCatDoc}
    />
  );
};

export default AdminCreateEventtypePage;
